import { IconSizes } from "../Icon"
import { AvatarSizes } from "./types"

export const AVATAR_DEFAULT_CLASSNAME =
  "group relative flex cursor-default items-center justify-center rounded-full bg-primary-lighten-100 text-primary-base"

export const AVATAR_CLASSNAME_BY_SIZE: Record<AvatarSizes, string> = {
  xs: "h-6 min-w-6 w-6 text-xs",
  sm: "h-8 min-w-8 w-8 text-xs",
  md: "h-10 min-w-10 w-10 text-base",
  lg: "h-12 min-w-12 w-12 text-base",
  xl: "h-14 min-w-14 w-14 text-2xl",
  "2xl": "h-16 min-w-16 w-16 text-2xl",
}

export const INDICATOR_DEFAULT_CLASSNAME =
  "absolute bottom-0 right-0 rounded-full border border-white"

export const INDICATOR_CLASSNAME_BY_SIZE = {
  xs: "h-1.5 w-1.5 text-xs border",
  sm: "h-2 w-2 text-xs border",
  md: "h-2.5 w-2.5 text-base border",
  lg: "h-3 w-3 text-base border-2",
  xl: "h-3.5 w-3.5 text-2xl border-2",
  "2xl": "h-4 w-4 text-2xl border-2",
}

export const PLACEHOLDER_ICON_SIZE: Record<AvatarSizes, IconSizes> = {
  xs: "xs",
  sm: "xs",
  md: "sm",
  lg: "sm",
  xl: "md",
  "2xl": "md",
}
